define('widgets/form_checkbox/viewmodel',['require'],function (require) {

    var Widget = function(element, settings) {
    };

    Widget.prototype.activate = function(settings) {

        var self = this;
        self.fieldName = settings.name;
        self.field = settings.field;
        self.hasFocus = ko.observable(false);
        self.hasBeenUpdated = ko.observable(false);
        self.isBusy = ko.observable(false);

        var dirtyFlag = new ko.DirtyFlag([self.field.value]);
        self.isDirty = ko.computed(function () {
            return dirtyFlag().isDirty();
        });

        self.isDisabled = ko.computed(function () {
            return self.isBusy() || !self.field.editable();
        });

        self.field.editLayout = ko.observable(false);
        self.field.editLayout.focus = function () { }; //placeholder
        self.field.editLayout.isFocus = ko.observable(false);
        self.field.editLayout.editList = function () { };

        self.showUpdatedIndicator = ko.computed(function () {
            return !self.hasFocus() && !self.isDirty() && self.hasBeenUpdated();
        });

        self.field.reset.subscribe(function (newValue) {
            if (newValue)
                self.hasBeenUpdated(false);
        });

        self.field.value.subscribe(function (newValue) {
            if (self.field.reset()) {
                self.field.reset(false);
                return;
            }
            self.hasFocus(false);
            self.isBusy(true);
            settings.update(self.field)
                .done(function () {
                    self.hasBeenUpdated(true);
                    dirtyFlag().reset();
                })
                .always(function() {
                    self.isBusy(false);
                });
        });

    };
    Widget.prototype.attached = function (viewHtml) {
        var self = this;

        $("input.controls-is-visible:checkbox", viewHtml).change(function () {
            self.field.visible(this.checked);
        });
    };

    return Widget;
});
